import React, { useState, useRef } from 'react';
import { Trash2 } from 'lucide-react';

const SwipeableListItem = ({ children, onDelete, disabled = false }) => {
  const [translateX, setTranslateX] = useState(0);
  const [isSwiping, setIsSwiping] = useState(false);
  const startXRef = useRef(0);
  const containerRef = useRef(null);

  const DELETE_THRESHOLD = -80;
  const MAX_SWIPE = -100;

  const handleTouchStart = (e) => {
    if (disabled) return;
    startXRef.current = e.touches[0].clientX;
    setIsSwiping(true);
  };

  const handleTouchMove = (e) => {
    if (!isSwiping || disabled) return;
    const currentX = e.touches[0].clientX;
    const diff = currentX - startXRef.current;

    // Only allow left swipe
    if (diff < 0) {
      setTranslateX(Math.max(diff, MAX_SWIPE));
    } else {
      setTranslateX(0);
    }
  };

  const handleTouchEnd = () => {
    if (disabled) return;
    setIsSwiping(false);

    if (translateX < DELETE_THRESHOLD) {
      // Keep open to show delete button
      setTranslateX(MAX_SWIPE);
    } else {
      // Snap back
      setTranslateX(0);
    }
  };

  const handleDelete = () => {
    setTranslateX(0);
    onDelete();
  };

  const handleClick = () => {
    // Reset swipe if clicked elsewhere
    if (translateX !== 0) {
      setTranslateX(0);
    }
  };

  return (
    <div
      ref={containerRef}
      className="relative overflow-hidden bg-surface"
      onClick={handleClick}
    >
      {/* Delete button behind */}
      <div className="absolute right-0 top-0 bottom-0 w-[100px] bg-error flex items-center justify-center">
        <button
          onClick={handleDelete}
          className="p-3 text-white hover:opacity-80 cursor-pointer"
          aria-label="Delete"
        >
          <Trash2 size={24} />
        </button>
      </div>

      {/* Main content */}
      <div
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
        className="bg-surface relative z-[1]"
        style={{
          transform: `translateX(${translateX}px)`,
          transition: isSwiping ? 'none' : 'transform 0.2s ease-out',
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default SwipeableListItem;
